import { PostHv } from "./helpers";

export const CreateSurveyAnswer = async (body: { [key: string]: any }, token: string | null): Promise<any> => {
	return PostHv('/e3-submit-survey', { ...body }, token || '');
};
